module.exports = __webpack_public_path__ + "images/marketing_site/CRM_Leader_Small-Business_Leader.svg";